import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Enterprise"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 10.5V21H22.5V22.5H1.5V21H3V3C3 2.17157 3.67157 1.5 4.5 1.5H15C15.8284 1.5 16.5 2.17157 16.5 3V9H19.5C20.3284 9 21 9.67157 21 10.5ZM9 7.5H10.5V10.5H9V7.5ZM9 12H10.5V15H9V12ZM13.5 7.5H12V10.5H13.5V7.5ZM12 12H13.5V15H12V12ZM10.5 16.5H9V19.5H10.5V16.5ZM12 16.5H13.5V19.5H12V16.5ZM4.5 3H15V21H4.5V3ZM16.5 10.5V21H19.5V10.5H16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Enterprise.vue"]]);
